export const CHROME_EXTENSION =
  'https://chrome.google.com/webstore/detail/vidami/injanakciaoflbhcecmnpdekfflnllfd?hl=en-US';
export const SAFARI_EXTENSION =
  'https://apps.apple.com/us/app/vidami-for-safari/id1514041763';
export const IOS_SAFARI_EXTENSION =
  'https://apps.apple.com/us/app/vidami-for-ios-safari/id1589070496';
